import * as Yup from 'yup';
import {
    manifestReferenceSchema,
    transportDetailsValidationSchema,
} from '../create-manifest-form/create-manifest.schemas';

export const updateManifestValidationSchema = manifestReferenceSchema
    .concat(transportDetailsValidationSchema)
    .omit(['arrivalDateTime'])
    .shape({
        arrivalDateTime: Yup.mixed()
            .transform((value) => (value === '' ? null : value))
            .nullable()
            .required('Arrival date/time is required'),
    });

export type UpdateManifestFormFields = Yup.InferType<typeof updateManifestValidationSchema>;
